import { guessLocale, } from '../translation/translation.js';
import { addLegacyPrefix, stripUniversalPrefix, } from './legacyPrefixRewrite.js';
import { addLocale, splitLocale, } from './localeRewrite.js';
import { fromLocalizedUrl, toLocalizedUrl, } from './translatedRoutesRewrite.js';
export function getInternalUrl(externalUrl) {
    // copy url, because we are going to modify it
    // and don't want to modify the original one
    const url = stripUniversalPrefix(new URL(externalUrl.href));
    const { pathname, locale, } = splitLocale(url.pathname);
    url.pathname = pathname;
    return {
        url: fromLocalizedUrl(url, locale),
        locale,
    };
}
export function getCurrentUrl() {
    return new URL(location.href, window.location.origin);
}
export function getExternalUrl(internalUrl, locale) {
    const newUrl = addLegacyPrefix(addLocale(locale, toLocalizedUrl(new URL(internalUrl.href), locale)));
    return newUrl;
}
/**
 * full url for seo purposes
 */
export function getExternalLanguageSelectorUrl(internalUrl) {
    const newUrl = addLegacyPrefix(toLocalizedUrl(new URL(internalUrl.href), guessLocale()));
    return newUrl;
}
/**
 * url as string without origin
 */
export function toRelativeUrl(url) {
    return url.pathname + url.search + url.hash;
}
//# sourceMappingURL=router.js.map